module.exports = __webpack_public_path__ + "img/guardian002.e8e3aa26.jpg";